import TemplateSettings from "@/module/Form/Resources/TemplateSettings";

export default function getDefaultTemplateSetting(): TemplateSettings {
  return {
    container_settings: {
      billing: {
        layout: {
          column: "single",
        },
      },
      payment: {
        allow_inline_payment_card: false,
        layout: {
          variant: "tile",
          column: "single",
        },
      },

      shipping: {
        layout: {
          column: "multi",
        },
      },
      is_two_step_form: false,
      two_step_form_type: "inline",
      two_step_redirect_url: undefined,
    },
  };
}
